import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideMail } from '@ng-icons/lucide';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { HlmIconDirective } from '@spartan-ng/ui-icon-helm';
import { ThemeService } from '../../services/theme.service';
import { EasterEggComponent } from '../easter-egg/easter-egg.component';
import { LogoWithTextComponent } from '../logo-with-text/logo-with-text.component';
import { NewsletterSubscribeComponent } from '../newsletter-subscribe/newsletter-subscribe.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  imports: [
    RouterLink,
    LogoWithTextComponent,
    EasterEggComponent,
    HlmButtonDirective,
    HlmIconDirective,
    NgIcon,
    NewsletterSubscribeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideIcons({ lucideMail })],
})
export class FooterComponent {
  private themeService = inject(ThemeService);

  private clickCount = signal(0);
  private lastClickTime = 0;
  private CLICK_TIMEOUT = 1000; // 1 second timeout between clicks

  currentYear: number = new Date().getFullYear();

  isEasterEggActive = signal(false);

  handleLogoClick() {
    if (this.isEasterEggActive()) return;

    const now = Date.now();
    if (!this.themeService.darkMode$ || now - this.lastClickTime > this.CLICK_TIMEOUT) {
      this.clickCount.set(0);
      this.lastClickTime = now;
      return;
    }

    this.lastClickTime = now;
    this.clickCount.update(count => count + 1);

    if (this.clickCount() >= 10) {
      this.isEasterEggActive.set(true);
      setTimeout(() => {
        this.isEasterEggActive.set(false);
        this.clickCount.set(0);
      }, 10000);
    }
    this.lastClickTime = now;
  }
}
